<mat-accordion>
  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title>
        <h2>{{ 'AdditionalDocuments' | translate }}</h2>
      </mat-panel-title>
    </mat-expansion-panel-header>
    @if (!readonly) {
      <div class="document-buttons">
        <button id="documents-section-add-other-document-button" mat-raised-button color="primary" (click)="openModal()">
          {{ 'WL-AddDocument' | translate }}
        </button>
      </div>
    }
    <div class="table-wrapper">
      <table class="additional-document-section-table">
        <thead>
          <tr>
            <th class="column-filetype">{{ 'WL-WorkerFileType' | translate }}</th>
            <th class="column-date">{{ 'CreatedOnDate' | translate }}</th>
            <th class="column-description">{{ 'Description' | translate }}</th>
            <th class="column-filename">{{ 'Name' | translate }}</th>
            <th class="column-isattached">{{ 'Status' | translate }}</th>
            <th class="column-actions">{{ 'Actions' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          @for (documentFile of documentFiles$ | async; track documentFile) {
            <tr>
              <td class="column-filetype">
                @for (sectionFile of documentFile?.SectionFiles; track sectionFile) {
                  <div>{{ sectionFile?.FileTypeName }}</div>
                }
              </td>
              <td class="column-date">
                @for (sectionFile of documentFile?.SectionFiles; track sectionFile) {
                  @for (workerFile of sectionFile?.WorkerFiles; track workerFile) {
                    <div>{{ workerFile?.CreatedOn | date : 'yyyy-MM-dd' }}</div>
                  }
                }
              </td>
              <td class="column-description">
                @for (sectionFile of documentFile?.SectionFiles; track sectionFile) {
                  <div class="column">
                    @for (workerFile of sectionFile?.WorkerFiles; track workerFile) {
                      <div>{{ workerFile?.Description }}</div>
                    }
                  </div>
                }
              </td>
              <td class="column-filename">
                @for (sectionFile of documentFile?.SectionFiles; track sectionFile) {
                  <ng-container class="column">
                    @for (workerFile of sectionFile?.WorkerFiles; track workerFile) {
                      <div>
                        <a href="javascript:void(0)" (click)="showFile(workerFile.Id, workerFile.Name, workerFile.AbsenceId)">{{ workerFile.Name }}</a>
                      </div>
                    }
                  </ng-container>
                }
              </td>
              <td class="column-isattached">
                @for (sectionFile of documentFile?.SectionFiles; track sectionFile) {
                  @if (!!sectionFile.WorkerFiles == false) {
                    <span><mat-icon>error</mat-icon></span>
                  }
                  @if (!!sectionFile.WorkerFiles == true) {
                    <span><mat-icon>check</mat-icon></span>
                  }
                }
              </td>
              <td class="column-actions">
                @for (sectionFile of documentFile?.SectionFiles; track sectionFile) {
                  @for (workerFile of sectionFile?.WorkerFiles; track workerFile) {
                    <div>
                      <button id="documents-section-download-other-document-button" mat-icon-button color="primary" (click)="downloadFile(workerFile.Id, workerFile.Name, workerFile.AbsenceId)">
                        <mat-icon>download</mat-icon>
                      </button>
                      @if (!workerFile.AbsenceId) {
                        <button id="documents-section-delete-other-document-button" mat-icon-button color="primary" [visibleWithPermissions]="['DeleteWorkerFiles']" (click)="deleteFile(workerFile.Id)">
                          <mat-icon>delete</mat-icon>
                        </button>
                      }
                    </div>
                  }
                }
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </mat-expansion-panel>
</mat-accordion>
